// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1Ched","productName":"Table_productName__9TRXn"};